export default function CustomersIcon({ name }) {
  const paths = {
    search: 'M21 21l-4.35-4.35m2.1-5.4a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z',
    filter: 'M4 6h16M7 12h10M10 18h4',
    plus: 'M12 5v14M5 12h14',
    car: 'M5 17h14M6 17l-1-4 2-5h10l2 5-1 4M8 17v2m8-2v2M7 13h.01M17 13h.01',
    edit: 'm4 20 4.2-1 10.6-10.6-3.2-3.2L5 15.8 4 20ZM14.5 6.3l3.2 3.2',
    trash: 'M5 7h14M9 7V4h6v3m2 0-1 13H8L7 7m3 4v5m4-5v5',
    service: 'M14.7 6.3a4 4 0 0 0-5.2 5.2L4 17l3 3 5.5-5.5a4 4 0 0 0 5.2-5.2l-2.4 2.4-3-3 2.4-2.4Z',
    users: 'M16 19v-1.5a3.5 3.5 0 0 0-3.5-3.5h-5A3.5 3.5 0 0 0 4 17.5V19m6-9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm7-1a2.5 2.5 0 0 0 0-5m2.5 15v-1.5a3 3 0 0 0-2.2-2.9',
    close: 'M6 6l12 12M18 6 6 18',
  };
  return <svg viewBox="0 0 24 24" aria-hidden="true"><path d={paths[name]} /></svg>;
}
